import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

import BackdropLoader from "../../../components/BackdropLoader";

import Counter from "../Counter";
import AddRecipient from "./AddRecipient";
import EditName from "./EditGroupName";
import List from "./List";

import { useGetGroupRecipientsQuery } from "../recipientsApiSlice";
import { RemoveGroup } from "../RemoveGroup";

const Group = ({ groupId, onNameChange, isChangingName, setActiveTab }) => {
	const {
		data: recipients,
		isLoading,
		isFetching,
	} = useGetGroupRecipientsQuery({ groupId });

	if (isLoading) {
		return (
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					gap: "12px",
					mt: "12px",
				}}
			>
				<Skeleton variant="rectangular" height={40} />
				<Skeleton variant="rectangular" height={800} />
			</Box>
		);
	}

	return (
		<>
			{/* <Box sx={{ position: "absolute", top: "20px", right: 0 }}>
				<Counter count={recipients.length} />
			</Box> */}
			<Box sx={{ position: "relative" }}>
				<Box
					sx={{
						position: "absolute",
						top: "13px",
						left: 0,
						zIndex: 120,
					}}
				>
					<Box
						sx={{
							flex: "0 0 auto",
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							flexWrap: "wrap",
							columnGap: "20px",
							rowGap: "14px",
						}}
					>
						<AddRecipient groupId={groupId} count={recipients.length} />
						<EditName
							onNameChange={onNameChange}
							isChangingName={isChangingName}
						/>
					</Box>
				</Box>
				<Box
					sx={{
						position: "absolute",
						top: "-4px",
						right: 0,
						zIndex: 120,
					}}
				>
					<Box
						sx={{
							flex: "0 0 auto",
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
							alignItems: "end",
							flexWrap: "wrap",
							columnGap: "20px",
							rowGap: "14px",
						}}
					>
						<Counter count={recipients.length} />
						<RemoveGroup
							count={recipients.length}
							groupId={groupId}
							setActiveTab={setActiveTab}
						/>
					</Box>
				</Box>
				<List data={recipients} groupId={groupId} />
			</Box>
			<BackdropLoader isOpen={isFetching} />
		</>
	);
};

export default Group;
